import { PostCode } from 'components/Supplier/Manage/Operations/ServicedAreas'
import * as React from 'react'
import { ChargeException } from '../../api/models/ChargeException.type'
import {
  ServicedArea,
  SupplierOperation,
} from '../../api/supplier/supplierOperationsAPI.types'
import { Taxi } from '../../api/vehicle/taxisAPI.types'

type Action =
  | { type: 'setSupplier'; payload: any }
  | { type: 'setSupplierOperation'; payload: any }
  | { type: 'setChargeExceptions'; payload: Array<ChargeException> }
  | { type: 'enableChargeException'; payload: any }
  | { type: 'setEnabledChargeExceptions'; payload: Array<ChargeException> }
  | { type: 'removeChargeException'; payload: any }
  | { type: 'setServicedAreas'; payload: any }
  | { type: 'addServicedAreas'; payload: Array<ServicedArea> }
  | { type: 'removeServicedArea'; payload: ServicedArea }
  | { type: 'setTaxis'; payload: Array<Taxi> }
type Dispatch = (action: Action) => void
interface State {
  supplier: any
  supplierOperation: SupplierOperation
  servicedAreas: Array<ServicedArea>
  servicedAreasToAdd: Array<PostCode>
  servicedAreasToRemove: Array<ServicedArea>
  taxis: Array<Taxi>
  chargeExceptions: Array<ChargeException>
  enabledChargeExceptions: Array<ChargeException>
}
type SupplierProviderProps = { children: React.ReactNode }

const SupplierStateContext = React.createContext<State | undefined>(undefined)
const SupplierDispatchContext = React.createContext<Dispatch | undefined>(
  undefined,
)

const pushToArray = (arr: Array<ChargeException>, obj: ChargeException) => {
  const index = arr.findIndex((e) => e.id === obj.id)
  if (index === -1) {
    arr.push(obj)
  } else {
    arr[index] = obj
  }
}

const supplierReducer = (state: State, action: Action) => {
  // console.log('Action ', action.type)
  // console.log('Payload ', action.payload)
  switch (action.type) {
    // case 'setSupplier': {
    //     return { ...state, supplier: action.payload }
    // }
    case 'setSupplierOperation': {
      return { ...state, supplierOperation: action.payload }
    }
    case 'setChargeExceptions': {
      return { ...state, chargeExceptions: action.payload }
    }
    case 'enableChargeException': {
      const newArray = [...state.enabledChargeExceptions]
      pushToArray(newArray, action.payload)
      return { ...state, enabledChargeExceptions: newArray }
    }
    case 'setEnabledChargeExceptions': {
      return { ...state, enabledChargeExceptions: action.payload }
    }
    case 'removeChargeException': {
      const newArray = [...state.enabledChargeExceptions]
      const updatedExceptions = newArray.filter(
        (exception: ChargeException) => exception.id !== action.payload.id,
      )
      return { ...state, enabledChargeExceptions: updatedExceptions }
    }
    case 'setServicedAreas': {
      return { ...state, servicedAreas: action.payload }
    }
    case 'addServicedAreas': {
      return { ...state, servicedAreasToAdd: action.payload }
    }
    case 'removeServicedArea': {
      const index = state.servicedAreas.indexOf(action.payload)
      const copy = [...state.servicedAreas]
      if (index !== -1) {
        copy.splice(index, 1)
      }
      if (action.payload.id) {
        return {
          ...state,
          servicedAreas: copy,
          servicedAreasToRemove: [
            ...state.servicedAreasToRemove,
            action.payload,
          ],
        }
      }
      return {
        ...state,
        servicedAreas: copy,
      }
    }
    case 'setTaxis': {
      return { ...state, taxis: action.payload }
    }
    default: {
      throw new Error('Unhandled action type')
    }
  }
}

const SupplierProvider = ({ children }: SupplierProviderProps) => {
  const initalState = {
    supplier: undefined,
    supplierOperation: undefined,
    servicedAreas: [],
    servicedAreasToRemove: [],
    servicedAreasToAdd: [],
    taxis: [],
    chargeExceptions: [],
    enabledChargeExceptions: [],
  }
  const [state, dispatch] = React.useReducer(supplierReducer, initalState)
  return (
    <SupplierStateContext.Provider value={state}>
      <SupplierDispatchContext.Provider value={dispatch}>
        {children}
      </SupplierDispatchContext.Provider>
    </SupplierStateContext.Provider>
  )
}
const useSupplierState = () => {
  const context = React.useContext(SupplierStateContext)
  if (context === undefined) {
    throw new Error('useSupplierState must be used within a SupplierProvider')
  }
  console.log('useSupplierState', context)
  return context
}
const useSupplierDispatch = () => {
  const context = React.useContext(SupplierDispatchContext)
  if (context === undefined) {
    throw new Error(
      'useSupplierDispatch must be used within a SupplierProvider',
    )
  }
  return context
}
export { SupplierProvider, useSupplierDispatch, useSupplierState }
